export const limitTo = (text, limitTo, dontShowDots) => {
  /**
   * @param {String} text - only text without html tags
   * @param {Number} limitTo - number of cute char
   **/

  let newText = '';

  if (text && text.length) {
    newText = text.slice(0, limitTo, dontShowDots);

    if (text.length > limitTo) {
      let end = dontShowDots ? ' ' : '...';

      return newText + end;
    } else {
      return newText;
    }
  } else {
    return text;
  }
};
